(function(){
    'use strict'

    angular
    .module('app.nacionalidades')
    .controller('EditarNacionalidad', EditarNacionalidad);

    EditarNacionalidad.$inject = ['$scope', '$animationsSrv', '$routeParams','NacionalidadesService', 'logger', '$location'];

    function EditarNacionalidad($scope, $animationsSrv, $routeParams, NacionalidadesService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.centrosCosto = [];

        vm.nacionalidadId = $routeParams.id ? $routeParams.id : 0;

        getNacionalidad();

        function getNacionalidad(){

            if(vm.nacionalidadId != 0){
                var promise = NacionalidadesService.getById(vm.nacionalidadId);

                promise
                .then(function(nacionalidad){
                    vm.nacionalidad = nacionalidad;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener la nacionalidad: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.nacionalidadForm.$valid){
                if(!vm.nacionalidad.id){
                    saveNacionalidad();
                }
                else if($scope.nacionalidadForm.$dirty){
                    updateNacionalidad();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveNacionalidad() {
            var promise = NacionalidadesService.save(vm.nacionalidad);
            
            promise
            .then(function(response){
                logger.success('Nacionalidad creada con éxito.');
                clearNacionalidadData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear la nacionalidad: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateNacionalidad(){
            var promise = NacionalidadesService.update(vm.nacionalidad);
            
            promise
            .then(function(response){
                logger.success('Nacionalidad modificada con éxito.');
                $location.path('/nacionalidades');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar la nacionalidad: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearNacionalidadData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.nacionalidad = {};
            // Set back to pristine.
            $scope.nacionalidadForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.nacionalidadForm.$setUntouched();
        };

    }
})();